import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-multi-date-picker";
import moment from "moment";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder";
import { Link, useNavigate } from "react-router-dom";
import { DropdownButton, DropdownToggle } from "../../Helpers/Components/Dropdown";
import Handler from "../../Helpers/Components/Handler";
import Select from 'react-select'

const Booking = () => {
    const latestRequest = useRef(0);
    const [chosen, setChosen] = useState("today")
    const [dateRange, setDateRange] = useState({ from: new Date(), to: new Date() })
    const [start, setStart] = useState(new Date())
    const [end, setEnd] = useState(new Date())
    const [details, setDetails] = useState(false)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [cart, setCart] = useState(localStorage.getItem('filter'));
    const [carDetails, setCarDetails] = useState([])
    const [leadList, setLeadList] = useState([])
    const [filter, setFilter] = useState({
        count:cart ? JSON?.parse(cart)?.count ? JSON?.parse(cart)?.count : 10 : 10,
        sortBy: "deliveryDetails.delivery",
        sort: true,
        search: cart ? JSON?.parse(cart)?.search ? JSON?.parse(cart)?.search : "" : "",
        createdBy: cart ? JSON?.parse(cart)?.createdBy ? JSON?.parse(cart)?.createdBy : "All" : "All",
        deliveryBy: cart ? JSON?.parse(cart)?.deliveryBy ? JSON?.parse(cart)?.deliveryBy : "All" : "All",
        carId: cart ? JSON?.parse(cart)?.carId ? JSON?.parse(cart)?.carId : "All" : "All",
        remarks: cart ? JSON?.parse(cart)?.remarks ? JSON?.parse(cart)?.remarks : "All" : "All",
        pickupBy: cart ? JSON?.parse(cart)?.pickupBy ? JSON?.parse(cart)?.pickupBy : "All" : "All",
        status: cart ? JSON?.parse(cart)?.status ? JSON?.parse(cart)?.status : "All" : "All",
        type: cart ? JSON?.parse(cart)?.type ? JSON?.parse(cart)?.type : "All" : "All",
        leadMode: cart ? JSON?.parse(cart)?.leadMode ? JSON?.parse(cart)?.leadMode : { label: "All", value: "All" } : { label: "All", value: "All" },
        leadAttendedBy: cart ? JSON?.parse(cart)?.leadAttendedBy ? JSON?.parse(cart)?.leadAttendedBy : { label: "All", value: "All" } : { label: "All", value: "All" },
    })

    const setPageNo = (value) => {
        navigate(`/booking/${value}`)
    }
    const setItem = (name, value) => {
        const existing = localStorage.getItem('filter');
        let oldData = existing ? JSON.parse(existing) : {};
        oldData[name] = value || "";
        localStorage.setItem('filter', JSON.stringify(oldData));
    };
    const sort = (sortBy, sort) => {
        setPageNo(1)
        setFilter((prev) => ({
            ...prev,
            sortBy: sortBy,
            sort: sort
        }))
        setItem('sortBy', sortBy)
        setItem('sort', sort)
    }
    const setFilteration = (name, value) => {
        setPageNo(1)
        setFilter((prev) => ({ ...prev, [name]: value }))
        setItem(name, value)
    }
    const getCarDetails = async () => {
        const response = await Handler({ method: 'get', url: `/car/list` })
        if (response?.success) {
            setCarDetails(response?.data)
        } else {
            setCarDetails([])
        }
    }
    const getLeadList = async () => {
        const response = await Handler({ method: "get", url: `/booking/lead-list`, })
        if (response?.success) {
            const lead = response?.data
            if (lead?.length) {
                setLeadList([{ label: "All", value: "All" },...(lead?.length ? lead?.map((element) => { return { label: element?.name?.toUpperCase(), value: element?.leadId } }) : [])])
            } else {
                setLeadList([])
            }
            // setLeadList([{ label: "All", value: "All" }, ...(response?.data?.length ? response?.data?.map((element) => { return { label: element?.name?.toUpperCase(), value: element?.leadId } }) : [])])
        } else {
            setLeadList([])
        }
    }
    const getCount = async () => {
        const requestId = ++latestRequest.current;
        setLoading(true)
        // const response = await Handler({ method: 'post', url: `/booking/dashboard`, data: { chosen, ...(chosen === "customize" ? { from: dateRange?.from || new Date(), to: dateRange?.to || dateRange?.from || new Date() } : {}) } });
        // if (requestId !== latestRequest.current) return;
        // if (response?.success) {

        // } else {

        // }
        setLoading(false)
    }
    useEffect(() => {
        getCount()
    }, [chosen, dateRange, filter])
    useEffect(() => {
        if (chosen === "today") {
            setStart(new Date(new Date()?.setHours(0, 0, 0, 0)))
            setEnd(new Date(new Date()?.setHours(23, 59, 59, 999)))
        }
        if (chosen === "week") {
            const current = new Date();
            const day = current.getUTCDay();
            const weekStart = new Date(current);
            weekStart.setUTCDate(current.getUTCDate() - day);
            const weekEnd = new Date(current);
            weekEnd.setUTCDate(current.getUTCDate() - day + 6);
            setStart(new Date(weekStart.getUTCFullYear(), weekStart.getUTCMonth(), weekStart.getUTCDate(), 0, 0, 0, 0));
            setEnd(new Date(weekEnd.getUTCFullYear(), weekEnd.getUTCMonth(), weekEnd.getUTCDate(), 23, 59, 59, 999));
        }
        if (chosen === "month") {
            const CUTOFF_DAY = 25;
            const CUTOFF_HOUR = 18;
            const current = new Date();
            let startMonth = current.getUTCMonth();
            let startYear = current.getUTCFullYear();
            if (current.getUTCDate() < CUTOFF_DAY || (current.getUTCDate() === CUTOFF_DAY && current.getUTCHours() < CUTOFF_HOUR)) {
                startMonth -= 1;
                if (startMonth < 0) {
                    startMonth = 11;
                    startYear -= 1;
                }
            }
            setStart(new Date(startYear, startMonth, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
            setEnd(new Date(startYear, startMonth + 1, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
        }
        if (chosen === "quarter") {
            const CUTOFF_DAY = 25;
            const CUTOFF_HOUR = 18;
            const current = new Date();
            let startMonth = current.getUTCMonth();
            let startYear = current.getUTCFullYear();
            if (current.getUTCDate() < CUTOFF_DAY || (current.getUTCDate() === CUTOFF_DAY && current.getUTCHours() < CUTOFF_HOUR)) {
                startMonth -= 3;
            }
            while (startMonth < 0) {
                startMonth += 12;
                startYear -= 1;
            }
            setStart(new Date(startYear, startMonth, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
            setEnd(new Date(startYear, startMonth + 3, CUTOFF_DAY, CUTOFF_HOUR, 0, 0, 0));
        }
        if (chosen === "year") {
            setStart(new Date(new Date().getUTCFullYear(), 0, 1, 0, 0, 0, 0));
            setEnd(new Date(new Date().getUTCFullYear(), 11, 31, 23, 59, 59, 999));
        }
        if (chosen === "customize" && dateRange?.from) {
            setStart(new Date(new Date(dateRange.from).setHours(0, 0, 0, 0)));
            setEnd(new Date(new Date(dateRange.to || dateRange.from).setHours(23, 59, 59, 999)));
        }
    }, [chosen, dateRange])
    useEffect(() => {
        // getSubadminList()
        getLeadList()
        getCarDetails()
    }, [])
    return (
        <React.Fragment>
            <div className="layout-card">
                <div className="mb-3 text-center fw-bold fs-5">{moment(start)?.format("DD/MM/YYYY hh:mm A")} - {moment(end)?.format("DD/MM/YYYY hh:mm A")}</div>
                <div className="text-center mb-4">
                    <div className="btn-group d-flex flex-column flex-lg-row" role="group" aria-label="Basic mixed styles example">
                        <button type="button" className={`btn dashboard-btns ${chosen === "today" ? "active-dashboard-btns" : ""}`} onClick={() => { setChosen("today") }}>Today</button>
                        <button type="button" className={`btn dashboard-btns ${chosen === "week" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("week")}>This Week</button>
                        <button type="button" className={`btn dashboard-btns ${chosen === "month" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("month")}>This Month</button>
                        <button type="button" className={`btn dashboard-btns ${chosen === "quarter" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("quarter")}>This Quarter</button>
                        <button type="button" className={`btn dashboard-btns ${chosen === "year" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("year")}>This Year</button>
                        <button type="button" className={`btn dashboard-btns ${chosen === "customize" ? "active-dashboard-btns" : ""}`} onClick={() => { setChosen("customize"); setDateRange({ from: new Date(), to: new Date() }) }}>Customize</button>
                        {/* <button type="button" className={`btn dashboard-btns ${chosen === "total" ? "active-dashboard-btns" : ""}`} onClick={() => setChosen("total")}>Total</button> */}
                    </div>
                </div>
                {
                    chosen === "customize"
                        ?
                        <div className="mt-4 justify-content-center row">
                            <div className="d-md-flex align-items-center col-lg-4 col-md-8">
                                <div className="me-2 filter-date datepicker-top">
                                    <DatePicker
                                        autoComplete="off"
                                        selected={dateRange?.from}
                                        id="from"
                                        timeIntervals={15}
                                        showYearDropdown
                                        value={dateRange?.from || ""}
                                        showMonthDropdown
                                        placeholderText="From"
                                        onChange={(date) => setDateRange((prevValues) => ({ ...prevValues, from: date }))}
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control form_input text-uppercase me-2"
                                    />
                                </div>
                                <div className="me-2 filter-date datepicker-top">
                                    <DatePicker
                                        autoComplete="off"
                                        selected={dateRange?.to}
                                        showYearDropdown
                                        showMonthDropdown
                                        id="from"
                                        placeholderText="To"
                                        timeIntervals={15}
                                        value={dateRange?.to || ""}
                                        onChange={(date) => setDateRange((prevValues) => ({ ...prevValues, to: date }))}
                                        dateFormat="dd/MM/yyyy"
                                        minDate={dateRange?.from}
                                        disabled={dateRange?.from === "" ? true : false}
                                        className="form-control form_input text-uppercase"
                                    />
                                </div>
                                {dateRange?.from === "" ? "" :
                                    <div className="mb-md-0 mb-2">
                                        <button className="py-0 px-1 d-flex align-items-center btn btn-danger" onClick={() => { setDateRange({ from: new Date(), to: new Date() }); }}>
                                            <i className='fa-xmark fa-solid'></i>
                                        </button></div>}
                            </div>
                        </div>
                        : ""
                }
                <div className="overflow mt-5 mb-4">
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "bookingId" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("bookingId", false)} >▲</i><i className={filter?.sortBy === "bookingId" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("bookingId", true)} >▼</i></div> Id</div></th>
                                <th className="sticky-cust">Cust</th>
                                <th>
                                    <DropdownToggle label={
                                        <>
                                            Car ID <i className="fa-solid fa-caret-down"></i>
                                        </>
                                    }>
                                        <DropdownButton label="All" className={`${filter?.carId === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("carId", "All") }} />
                                        {
                                            carDetails?.length ?
                                                carDetails?.map((element, i) => {
                                                    return (
                                                        <DropdownButton key={i} label={element?.carId} className={`${filter?.carId === element?.id ? "active-option" : ""} text-uppercase`} onClick={() => { setFilteration("carId", element?.id) }} />
                                                    )
                                                })
                                                : ""
                                        }
                                    </DropdownToggle>
                                </th>
                                <th className="text-center">
                                    <DropdownToggle label={
                                        <>
                                            Status <i className="fa-solid fa-caret-down"></i>
                                        </>
                                    }>
                                        <DropdownButton label="All" className={`${filter?.status === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "All") }} />
                                        <DropdownButton label="Initiated" className={`${filter?.status === "Initiated" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Initiated") }} />
                                        <DropdownButton label="Booked" className={`${filter?.status === "Booked" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Booked") }} />
                                        <DropdownButton label="Cancelled" className={`${filter?.status === "Cancelled" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Cancelled") }} />
                                        <DropdownButton label="Ongoing" className={`${filter?.status === "Ongoing" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Ongoing") }} />
                                        <DropdownButton label="Pending" className={`${filter?.status === "Pending" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Pending") }} />
                                        <DropdownButton label="Completed" className={`${filter?.status === "Completed" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Completed") }} />
                                        <DropdownButton label="Verified" className={`${filter?.status === "Verified" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Verified") }} />
                                        <DropdownButton label="Correction" className={`${filter?.status === "Correction" ? "active-option" : ""}`} onClick={() => { setFilteration("status", "Correction") }} />
                                    </DropdownToggle>
                                </th>
                                <th> <div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "deliveryDetails.delivery" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("deliveryDetails.delivery", false)} >▲</i><i className={filter?.sortBy === "deliveryDetails.delivery" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("deliveryDetails.delivery", true)} >▼</i></div> <button className='created-at' onClick={() => {  }}> DL <i className="fa-solid fa-caret-down"></i> </button>  </div>  </th>
                                <th> <div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "pickupDetails.pickup" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("pickupDetails.pickup", false)} >▲</i><i className={filter?.sortBy === "pickupDetails.pickup" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("pickupDetails.pickup", true)} >▼</i></div> <button className='created-at' onClick={() => {  }}> PK <i className="fa-solid fa-caret-down"></i> </button>  </div>  </th>
                                <th>
                                    <DropdownToggle label={
                                        <>
                                            Delivery By <i className="fa-solid fa-caret-down"></i>
                                        </>
                                    }>
                                        <DropdownButton label="All" className={`${filter?.deliveryBy === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("deliveryBy", "All") }} />
                                        {
                                            leadList?.length ?
                                                leadList?.filter(element => element?.label !== "All")?.map((element, i) => {
                                                    return (
                                                        <DropdownButton key={i} label={element?.label} className={`${filter?.deliveryBy === element?.value ? "active-option" : ""} text-uppercase`} onClick={() => { setFilteration("deliveryBy", element?.value) }} />
                                                    )
                                                })
                                                : ""
                                        }
                                    </DropdownToggle>
                                </th>
                                <th>
                                    <DropdownToggle label={
                                        <>
                                            Pickup By <i className="fa-solid fa-caret-down"></i>
                                        </>
                                    }>
                                        <DropdownButton label="All" className={`${filter?.pickupBy === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("pickupBy", "All") }} />
                                        {
                                            leadList?.length ?
                                                leadList?.filter(element => element?.label !== "All")?.map((element, i) => {
                                                    return (
                                                        <DropdownButton key={i} label={element?.label} className={`${filter?.pickupBy === element?.value ? "active-option" : ""} text-uppercase`} onClick={() => { setFilteration("pickupBy", element?.value) }} />
                                                    )
                                                })
                                                : ""
                                        }
                                    </DropdownToggle>
                                </th>
                                <th>
                                    <DropdownToggle label=
                                        {<>
                                            Remarks <i className="fa-solid fa-caret-down"></i>
                                        </>}>
                                        <DropdownButton label="All" className={`${filter?.remarks === "All" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "All") }} />
                                        <DropdownButton label="Good" className={`${filter?.remarks === "Good" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "Good") }} />
                                        <DropdownButton label="Bad" className={`${filter?.remarks === "Bad" ? "active-option" : ""}`} onClick={() => { setFilteration("remarks", "Bad") }} />
                                    </DropdownToggle>
                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (details && details?.length !== 0 ? details?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row ${value?.status === "Pending" || value?.status === "Cancelled" || (value?.carStatus === false && value?.status !== "Completed") || (value?.excessCharges?.length && value?.excessCharges?.filter(element => element?.name === "damage")?.length && Number(value?.excessCharges?.filter(element => element?.name === "damage")[0]?.amount) > 0) || (value.pendingPhoto?.length > 0) ? "text-red" : ""}`}>
                                            <td><a className="" href={`/booking/view/${value?.bookingId}`}>{value?.verified ? <i className="fa-solid fa-circle-check text-success"></i> : ""} {value?.bookingId}</a></td>
                                            <td className="sticky-cust">
                                                <i className="fa-solid fa-circle-info cursor-pointer me-1" onClick={() => {  }}></i>
                                                <a href={`/customer/view/${value?.customerId}`}>
                                                    {value?.customerId}
                                                </a>
                                                <div className="text-capitalize">
                                                    {(value?.firstName || "") + " " + (value?.lastName || "")}
                                                </div>
                                            </td>
                                            <td>{value?.carId}</td>
                                            <td className={`${value?.status === "Completed" ? "text-green" : value?.status === "Ongoing" ? "text-yellow" : value === "Pending" ? "text-red" : ""} fw-bold text-center`}>
                                                <div className="d-flex flex-column align-items-center">
                                                    <span>{value?.status || "Initiated"}</span>
                                                    {value?.verified ? <span className="verified-text">Verified</span> : ""}
                                                    {value?.pendingPhoto?.length && value?.status === "Completed" ? <span className="verified-text">Pending & Closed</span> : ""}
                                                    {!value?.verified && value?.correction?.correction ? <span className="verified-text">Correction</span> : ""}
                                                </div>
                                            </td>
                                            <td>{value?.deliveryDetails?.delivery ? moment(new Date(value?.deliveryDetails?.delivery)).format("DD/MM/YYYY hh:mm A") : ""}
                                                <div className="text-uppercase">{value?.deliveryDetails?.location || ""}</div>
                                            </td>
                                            <td>{value?.pickupDetails?.pickup ? moment(new Date(value?.pickupDetails?.pickup)).format("DD/MM/YYYY hh:mm A") : ""}
                                                <div className="text-uppercase">{value?.pickupDetails?.location || ""}</div>
                                            </td>
                                            <td className="text-capitalize">{value?.stageHistory?.length ? value?.stageHistory?.filter(element => element?.stage === "Ongoing")?.length ? value?.stageHistory?.filter(element => element?.stage === "Ongoing")[0]?.staffName : "-" : "-"}</td>
                                            <td className="text-capitalize">{value?.stageHistory?.length ? value?.stageHistory?.filter(element => element?.stage === "Completed")?.length ? value?.stageHistory?.filter(element => element?.stage === "Completed")[0]?.staffName : "-" : "-"}</td>
                                            <td>{value?.remarks || "-"}</td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={10}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={10} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                   <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setFilteration("count", Number(selectedoption?.value))
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={filter?.count ? {label: filter?.count, value: filter?.count} : {label: 10, value: 10}}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
            </div>
        </React.Fragment>
    )
}

export default Booking;